import React, { memo, useCallback } from 'react';

import { Box, Typography } from '@mui/material';
import CheckboxCDS from '@sharedCR/coreDesignSystem/form/CheckboxCDS';
import PropTypes from 'prop-types';

import { attestationDescriptionStyles, attestationItemStyles } from '../../SendStep.styles';
import { SendStepTestIds } from '../../SendStep.testIds';

const AttestationCheckItem = ({ attestation, checked, disabled, onToggle }) => {
  const handleChange = useCallback(
    (_event, nextChecked) => onToggle(attestation.type, nextChecked),
    [onToggle, attestation.type],
  );

  return (
    <Box sx={attestationItemStyles}>
      <CheckboxCDS
        dataTestId={SendStepTestIds.getAttestationId(attestation.type)}
        disabled={disabled}
        label={<Typography variant="medium14">{attestation.label}</Typography>}
        value={checked}
        onChange={handleChange}
      />
      <Typography sx={attestationDescriptionStyles} variant="regular12">
        {attestation.description}
      </Typography>
    </Box>
  );
};

AttestationCheckItem.propTypes = {
  attestation: PropTypes.shape({
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
  onToggle: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default memo(AttestationCheckItem);
